(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('TransactionOrdersCtrl', TransactionOrdersCtrl);

  // @ngInject
  function TransactionOrdersCtrl(storeKeys, $translate, filters, DateUtil, ConsumerChart, TransactionReports, StandardReports,
                                 Callout, CalloutLabelService, SectionConfig, ConsumerChartDisplay) {
    var vm = this;

    var detailLevel = filters.pathParams.detailLevel;

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.transactionColorSwatch = StandardReports.getColorSwatches();

    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});
    vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };

    vm.ordersForConversionSection = Callout.labelValueConfig(SectionConfig.ordersForConversion);
    vm.ordersForConversionChartData = function (rawData) {
      return rawData;
    };


    vm.totalOrdersSection = Callout.usedForReportingConfig(SectionConfig.totalOrders);
    vm.totalOrderChartData = function(rawData) {
      return rawData;
    };

    vm.tfOrdersSection = Callout.usedForReportingConfig(SectionConfig.tfOrders);
    vm.tfOrderChartData = function(rawData) {
      return rawData;
    };

    vm.nonTFOrdersSection = Callout.usedForReportingConfig(SectionConfig.nonTFOrders);
    vm.nonTFOrderChartData = function(rawData) {
      return rawData;
    }
  }
  })();
